<template>
  <div class="ios-glass-page">
    <!-- 背景层 -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
    </div>

    <!-- 顶部筛选胶囊 -->
    <div class="filter-bar">
      <div class="glass-capsule" @click="dayShow = true">
        <span class="label">日期</span>
        <span class="value">{{ displayDate }}</span>
        <van-icon name="arrow-down" size="10" color="#8E8E93" />
      </div>
      <div class="glass-capsule" @click="sunrunPickerVisible = true">
        <span class="label">状态</span>
        <span class="value">{{ statusFil[searchObj.status] }}</span>
        <van-icon name="arrow-down" size="10" color="#8E8E93" />
      </div>

       <div class="glass-capsule" @click="openClassPicker">
        <span class="label">班级</span>
        <span class="value">{{ searchObj.classNameAll || '选择班级' }}</span>
        <van-icon name="arrow-down" size="10" color="#8E8E93" />
      </div>
    </div>

    <!-- 仪表盘卡片 -->
    <div class="glass-card dashboard-panel">
      <div class="panel-left">
        <van-circle
          v-model="formData.percentNum"
          :rate="formData.percentNum"
          :speed="100"
          size="90px"
          :stroke-width="80"
          layer-color="rgba(0,0,0,0.03)"
          :color="gradientColor"
        >
          <div class="circle-inner">
            <div class="percent">{{ formData.percentNum }}<small>%</small></div>
            <div class="desc">出勤率</div>
          </div>
        </van-circle>
      </div>
      <div class="panel-right">
        <div class="stat-row">
          <div class="stat-box">
            <div class="num">{{ formData.allNum }}</div>
            <div class="txt">总人数</div>
          </div>
          <div class="stat-box">
            <div class="num text-blue">{{ formData.testNum }}</div>
            <div class="txt">已出勤</div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="stat-row">
          <div class="stat-box">
            <div class="num text-green">{{ formData.goodNum || 0 }}</div>
            <div class="txt">已达标</div>
          </div>
          <div class="stat-box">
            <div class="num text-orange">{{ unFinishNum }}</div>
            <div class="txt">未达标</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 列表标题 -->
    <div class="section-header">
      <span>学生跑步记录</span>
      <span class="sub-text">共 {{ total }} 条数据</span>
    </div>

    <!-- 列表内容 -->
    <div class="list-container">
      <div v-if="dataList.length === 0" class="empty-state">
        <van-icon name="records" size="40" color="rgba(0,0,0,0.1)" />
        <p>暂无数据</p>
      </div>

      <div 
        v-else
        v-for="(item, index) in dataList" 
        :key="index" 
        class="glass-item-row"
      >
        <!-- 左侧：头像与基础信息 -->
        <div class="row-left">
          <div class="info">
            <div class="name-line">
              <span class="name">{{ item.studentName }}</span>
              <span class="sex-icon" v-if="item.sex === '女'"><van-icon name="friends" color="#FF2D55" /></span>
              <span class="sex-icon" v-else><van-icon name="manager" color="#007AFF" /></span>
            </div>
            <div class="class-line">
              {{ item.gradeName }} {{ item.className }} · {{ item.snCode }}
            </div>
          </div>
        </div>

        <!-- 右侧：数据展示 -->
        <div class="row-right">
          <div class="metric-main" :class="+item.status === 1 ? 'text-green' : 'text-orange'">
            <span class="val">{{ item.score }}</span>
            <span class="unit">m</span>
          </div>
          <div class="metric-sub">
            <van-icon name="clock-o" /> {{ formatSeconds(item.sportTime) }}
          </div>
        </div>
      </div>
    </div>

    <!-- 分页器 (样式优化版) -->
    <div class="pagination-container">
      <el-pagination
        small
        :pager-count="5"
        layout="prev, pager, next"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 底部下载栏 -->
    <div class="bottom-safe-area">
      <div class="download-bar" @click="downloadExcel">
        <div class="icon-circle"><van-icon name="down" /></div>
        <div class="text">导出日报数据表</div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-calendar v-model="dayShow" @confirm="onConfirmDay" color="#007AFF" :min-date="minDate" />
    <van-popup v-model="sunrunPickerVisible" position="bottom" round>
      <van-picker show-toolbar title="选择状态" :columns="columnsunrun" @confirm="onsunrunPickerConfirm" @cancel="sunrunPickerVisible = false" />
    </van-popup>

    <!-- 5. 班级选择器 (年级快捷胶囊栏 + 班级滚轮) -->
    <van-popup v-model="classShowPicker" round position="bottom" class="glass-popup" @close="onCancelPicker">
       <div class="popup-header">
         <div class="btn cancel" @click="onCancelPicker">取消</div>
         <div class="title">选择班级</div>
         <div class="btn confirm" @click="onConfirmPicker">确定</div>
       </div>

       <!-- 年级快捷胶囊栏 -->
       <div v-if="gradeList && gradeList.length > 1" class="grade-capsule-bar">
         <div class="grade-scroll-wrap">
           <div 
             v-for="grade in gradeList" 
             :key="grade.code"
             class="grade-pill"
             :class="{ active: tempGrade === grade.code }"
             @click="handleGradePillClick(grade.code)"
           >
             <span class="grade-name">{{ grade.name }}</span>
             <span class="grade-count">({{ grade.count }})</span>
           </div>
         </div>
       </div>

       <van-picker 
         ref="classPicker" 
         :columns="filteredClassList" 
         :default-index="currentClassIndex"
         :show-toolbar="false" 
         item-height="44" 
       />
    </van-popup>
  </div>
</template>

<script>
import { selectSunRunTestNum, getSunRunTestNumExcel } from "@/api/teacher/teacherSunrunScore.js";
import { getClassInfoList } from "@/api/teacher/teacherScore.js";
import { Dialog } from 'vant';
import moment from 'moment';

export default {
  name: 'SunRunEnhanced',
  data() {
    return {
      dayShow: false,
      sunrunPickerVisible: false,
      minDate: new Date(2023, 0, 1),
      columnsunrun: [
        { text: '全部状态', value: '' },
        { text: '未完成', value: 0 },
        { text: '已完成', value: 1 },
      ],
      statusFil: { '': '全部状态', 0: "未完成", 1: "已完成" },
      dataList: [],
      total: 0,
      pageIndex: 1,
      pageSize: 20,
      searchObj: { 
        day: '', 
        status: '',
        classCode: '',
        classNameAll: '',
        className: '',
        gradeCode: '',
        gradeName: '',
        selectedGrade: 'ALL'
      },
      excelUrl: '',
      formData: { allNum: 0, testNum: 0, goodNum: 0, percentNum: 0 },
      gradientColor: {
        '0%': '#34C759',
        '100%': '#007AFF',
      },
      classShowPicker: false,
      allClassList: [],
      tempGrade: 'ALL',
    };
  },
  computed: {
    displayDate() {
      return moment(this.searchObj.day).format('MM-DD') || '选择日期';
    },
    unFinishNum() {
      const res = +this.formData.allNum - +this.formData.goodNum;
      return res >= 0 ? res : 0;
    },
    gradeList() {
      if (!this.allClassList || this.allClassList.length === 0) return [];
      const map = new Map();
      this.allClassList.forEach(item => {
        const key = item.gradeKey;
        const name = item.gradeName || '未分年级';
        if (!map.has(key)) {
          map.set(key, { code: key, name: name, count: 0 });
        }
        map.get(key).count++;
      });
      return [
        { code: 'ALL', name: '全部年级', count: this.allClassList.length },
        ...Array.from(map.values())
      ];
    },
    filteredClassList() {
      if (!this.tempGrade || this.tempGrade === 'ALL') {
        return [
          { text: '全部班级', className: '全部班级', value: '', gradeCode: '', gradeName: '' },
          ...this.allClassList
        ];
      }
      return this.allClassList.filter(item => item.gradeKey === this.tempGrade);
    },
    currentClassIndex() {
      if (!this.searchObj.classCode || !this.filteredClassList.length) return 0;
      let idx = this.filteredClassList.findIndex(item => 
        item.value === this.searchObj.classCode && 
        (!this.searchObj.className || item.className === this.searchObj.className || item.text === this.searchObj.className)
      );
      if (idx < 0) {
        idx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
      }
      return idx >= 0 ? idx : 0;
    }
  },
  created() {
    this.searchObj.day = moment().format('YYYY-MM-DD');
    this.getList();
    this.init();
  },
  methods: {
    init() { 
      getClassInfoList({}).then(res => {
        const rawList = (res && res.data && res.data.data) || [];
        const seen = new Set();
        const uniqueList = [];
        rawList.forEach(item => {
          if (item && item.classCode) {
            const text = `${(item.gradeName || '').trim()} ${(item.className || '').trim()}`.trim() || item.className;
            const key = `${item.classCode}_${text}`;
            if (!seen.has(key)) {
              seen.add(key);
              uniqueList.push({
                text: text,
                className: item.className,
                value: item.classCode,
                gradeCode: item.gradeCode,
                gradeName: (item.gradeName || '').trim(),
                gradeKey: String(item.gradeCode || item.gradeName || 'other')
              });
            }
          }
        });
        this.allClassList = uniqueList;
      }).catch(() => {});
    },
    openClassPicker() {
      this.tempGrade = this.searchObj.selectedGrade || 'ALL';
      this.classShowPicker = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
            this.$refs.classPicker.setColumnIndex(0, this.currentClassIndex);
          }
        });
      });
    },
    handleGradePillClick(gradeCode) {
      if (this.tempGrade === gradeCode) return;
      this.tempGrade = gradeCode;
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
            let targetIdx = 0;
            if (this.searchObj.classCode) {
              const foundIdx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
              if (foundIdx >= 0) {
                targetIdx = foundIdx;
              }
            }
            this.$refs.classPicker.setColumnIndex(0, targetIdx);
          }
        });
      });
    },
    onCancelPicker() {
      this.classShowPicker = false;
      this.tempGrade = this.searchObj.selectedGrade || 'ALL';
    },
    onConfirmPicker() {
      if (this.$refs.classPicker) {
        if (typeof this.$refs.classPicker.confirm === 'function') {
          this.$refs.classPicker.confirm();
        }
        let val = null;
        if (typeof this.$refs.classPicker.getValues === 'function') {
          const vals = this.$refs.classPicker.getValues();
          val = vals && vals[0];
        }
        if (!val && typeof this.$refs.classPicker.getColumnIndex === 'function') {
          const cIdx = this.$refs.classPicker.getColumnIndex(0);
          val = this.filteredClassList[cIdx];
        }
        if (!val && this.filteredClassList.length > 0) {
          val = this.filteredClassList[0];
        }
        if (val) {
          this.pageIndex = 1;
          this.searchObj.selectedGrade = this.tempGrade || 'ALL';
          this.searchObj.classCode = val.value;
          this.searchObj.classNameAll = val.className;
          this.searchObj.className = val.className;
          this.searchObj.gradeCode = val.gradeCode;
          this.searchObj.gradeName = val.gradeName;
          this.getList();
          this.classShowPicker = false;
          return;
        }
      }
      this.classShowPicker = false;
    },
    formatSeconds(value) {
      if (!value) return '0″';
      let second = parseInt(value);
      let minute = 0;
      if (second > 60) {
        minute = parseInt(second / 60);
        second = parseInt(second % 60);
      }
      return minute > 0 ? `${minute}′${second}″` : `${second}″`;
    },
    onConfirmDay(date) {
      this.searchObj.day = moment(date).format('YYYY-MM-DD');
      this.dayShow = false;
      this.pageIndex = 1;
      this.getList();
    },
    onsunrunPickerConfirm(val) {
      this.searchObj.status = val.value;
      this.sunrunPickerVisible = false;
      this.pageIndex = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
      const listTop = document.querySelector('.list-container');
      if(listTop) listTop.scrollIntoView({ behavior: 'smooth' });
    },
    getList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true });
      selectSunRunTestNum({
        day: this.searchObj.day,
        status: this.searchObj.status,
        classCode: this.searchObj.classCode,
        gradeCode: this.searchObj.gradeCode,
        projectCode: 'SunRun',
        pageSize: this.pageSize,
        current: this.pageIndex
      }).then(res => {
        this.formData = res.data.obj || {};
        this.formData.percentNum = this.formData.allNum > 0 
          ? Math.round((this.formData.testNum / this.formData.allNum) * 100) 
          : 0;
        this.dataList = (res.data.body && res.data.body.list) || [];
        this.total = (res.data.body && res.data.body.total) || 0;
        this.$toast.clear();
      }).catch(() => this.$toast.clear());
    },
    async downloadExcel() {
      await getSunRunTestNumExcel({
        day: this.searchObj.day,
        status: this.searchObj.status,
        classCode: this.searchObj.classCode,
        gradeCode: this.searchObj.gradeCode,
        projectCode: 'SunRun',
        pageSize: 9999,
        current: 1
      }).then(res => {
        this.excelUrl = res.data.body.url;
      });
      if (!this.excelUrl) return this.$toast('暂无数据可导出');

      const url = window.location.origin + this.excelUrl;
      this.copyText(url);
      Dialog.alert({
        title: '链接已复制',
        message: '下载链接已复制到剪贴板。请打开浏览器粘贴链接进行下载。',
        confirmButtonColor: '#007AFF',
        theme: 'round-button'
      });
    },
    copyText(text) {
      const input = document.createElement('input');
      input.setAttribute('value', text);
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
  }
};
</script>

<style lang="less" scoped>
/* ---------------- 基础设置 ---------------- */
.ios-glass-page {
  min-height: 100vh;
  background: #F2F2F7;
  padding: 16px;
  padding-bottom: 100px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", sans-serif;
  color: #1c1c1e;
  position: relative;
  overflow-x: hidden;
}

/* 柔和光斑 */
.background-blobs {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none;
  .blob { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.6; }
  .blob-1 { width: 300px; height: 300px; background: #e0f2ff; top: -100px; left: -100px; }
  .blob-2 { width: 250px; height: 250px; background: #ffece6; top: 20%; right: -50px; }
}

/* 顶部筛选 */
.filter-bar {
  display: flex; gap: 8px; margin-bottom: 14px; position: relative; z-index: 1;
}

.glass-capsule {
  flex: 1;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 8px 12px;
  display: flex; align-items: center; justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  cursor: pointer;
  
  .label { font-size: 11px; color: #8E8E93; }
  .value { font-size: 13px; font-weight: 600; color: #007AFF; max-width: 65px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}

/* 仪表盘卡片 */
.glass-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.dashboard-panel {
  display: flex; padding: 16px 14px; margin-bottom: 20px; position: relative; z-index: 1;
  align-items: center;
  
  .panel-left {
    flex-shrink: 0; padding-right: 12px;
    .circle-inner {
      text-align: center;
      .percent { font-size: 20px; font-weight: 700; color: #1c1c1e; small { font-size: 12px; } }
      .desc { font-size: 10px; color: #8E8E93; }
    }
  }
  
  .panel-right {
    flex: 1;
    .stat-row {
      display: flex; justify-content: space-around;
      .stat-box {
        text-align: center;
        .num { font-size: 18px; font-weight: 700; color: #1c1c1e; font-family: 'DIN Alternate', sans-serif; }
        .txt { font-size: 11px; color: #8E8E93; margin-top: 2px; }
        .text-blue { color: #007AFF; }
        .text-green { color: #34C759; }
        .text-orange { color: #FF9500; }
      }
    }
    .divider { height: 1px; background: rgba(0,0,0,0.05); margin: 8px 0; }
  }
}

/* 列表标题 */
.section-header {
  display: flex; justify-content: space-between; align-items: baseline;
  padding: 0 4px 8px 4px;
  font-size: 16px; font-weight: 700; color: #1c1c1e;
  .sub-text { font-size: 12px; color: #8E8E93; font-weight: normal; }
}

/* 列表容器 */
.list-container {
  display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px;
}

.glass-item-row {
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 16px;
  padding: 12px 14px;
  display: flex; justify-content: space-between; align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
  
  .row-left {
    display: flex; align-items: center; gap: 10px;
    .info {
      .name-line {
        display: flex; align-items: center; gap: 4px;
        .name { font-size: 15px; font-weight: 600; color: #1c1c1e; }
        .sex-icon { font-size: 12px; }
      }
      .class-line { font-size: 11px; color: #8E8E93; margin-top: 2px; }
    }
  }
  
  .row-right {
    text-align: right;
    .metric-main {
      font-size: 18px; font-weight: 700; font-family: 'DIN Alternate', sans-serif;
      .unit { font-size: 11px; font-weight: normal; margin-left: 1px; }
      &.text-green { color: #34C759; }
      &.text-orange { color: #FF9500; }
    }
    .metric-sub {
      font-size: 11px; color: #8E8E93; margin-top: 2px; display: flex; align-items: center; justify-content: flex-end; gap: 2px;
    }
  }
}

.empty-state {
  text-align: center; padding: 40px; color: #AEAEB2; font-size: 13px;
  p { margin-top: 8px; }
}

/* ---------------- 分页器魔改 ---------------- */
.pagination-container {
  display: flex; justify-content: center; padding: 10px 0; margin-bottom: 20px;
}

::v-deep .el-pagination.el-pagination--small {
  .btn-prev, .btn-next, .el-pager li {
    background: rgba(255,255,255,0.6) !important;
    border-radius: 8px !important;
    min-width: 32px !important;
    height: 32px !important;
    line-height: 32px !important;
    margin: 0 4px;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);
  }
  
  .el-pager li.active {
    background: #007AFF !important;
    color: #fff !important;
    box-shadow: 0 4px 10px rgba(0, 122, 255, 0.3);
  }
}

/* ---------------- 底部下载栏 ---------------- */
.bottom-safe-area {
  position: fixed; bottom: 0; left: 0; right: 0; z-index: 99;
  padding: 16px 20px 34px;
  background: linear-gradient(to top, rgba(242,242,247,0.95), rgba(242,242,247,0.8));
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0,0,0,0.05);
}

.download-bar {
  background: #1c1c1e;
  height: 50px; border-radius: 25px;
  display: flex; align-items: center; justify-content: center; gap: 10px;
  color: #fff; cursor: pointer;
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
  transition: transform 0.1s;
  
  &:active { transform: scale(0.98); opacity: 0.9; }
  
  .icon-circle {
    width: 24px; height: 24px; background: rgba(255,255,255,0.2); border-radius: 50%;
    display: flex; align-items: center; justify-content: center; font-size: 14px;
  }
  .text { font-size: 16px; font-weight: 600; }
}

/* 底部弹窗 */
.glass-popup { background: #f2f2f7; }
.popup-header {
  display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background: #fff;
  .btn { font-size: 15px; cursor: pointer; }
  .cancel { color: #8e8e93; }
  .confirm { color: #007AFF; font-weight: 600; }
  .title { font-weight: 600; font-size: 16px; }
}

/* 年级快捷胶囊栏 */
.grade-capsule-bar {
  padding: 10px 16px 8px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  .grade-scroll-wrap {
    display: flex;
    overflow-x: auto;
    gap: 8px;
    padding-bottom: 2px;
    
    /* 隐藏滚动条 */
    &::-webkit-scrollbar { display: none; width: 0; height: 0; }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .grade-pill {
    flex-shrink: 0;
    padding: 6px 14px;
    border-radius: 16px;
    font-size: 13px;
    background: rgba(118, 118, 128, 0.08);
    color: #636366;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
    font-weight: 500;

    .grade-count {
      font-size: 11px;
      opacity: 0.75;
    }

    &.active {
      background: #007AFF;
      color: #fff;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);

      .grade-count {
        opacity: 0.9;
      }
    }

    &:active {
      transform: scale(0.96);
    }
  }
}
</style>
